export class ListZeroEtlPoliciesFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "StringFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListZeroEtlPoliciesFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
